import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useLayoutEffect,
} from "react";
import YouTube from "react-youtube";
import { ProgressBar } from "react-bootstrap";
//import playlists from "../services/playlists";
import {
  CurrentPlaylistContext,
  FAVOURITES_PLAYLIST_ID,
} from "../contexts/CurrentPlaylistContext"; // Import the CurrentPlaylistContext
import { PlayerContext } from "../contexts/PlayerContext"; // Import the PlayerContext
import Playlist from "./Playlist";

import { motion } from "framer-motion";
import Links from "./Links";
import { FavouritesContext } from "../contexts/FavouritesContext";

const Player = ({ isMinimized = false }) => {
  // eslint-disable-next-line no-unused-vars
  const [player, setPlayer] = useState(null);
  const [songInfo, setSongInfo] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [isPlayingOrPaused, setIsPlayingOrPaused] = useState(false);
  const [isPlayerVisible, setPlayerVisible] = useState(true);
  const [isPlaylistVisible, setPlaylistVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isForcedSkip, setIsForcedSkip] = useState(false);
  const [forcedSkipTimeoutID, setForcedSkipTimeoutID] = useState(null);
  const [localDuration, setLocalDuration] = useState({
    duration: 0,
    durationformattedTime: "00:00",
  });

  // Use shared player context
  const {
    isPlaying,
    setIsPlaying,
    isPlayerReady,
    setIsPlayerReady,
    setIsPlayerError,
    setPlayer: setSharedPlayer,
    setDuration: setSharedDuration,
    playerRef,
  } = useContext(PlayerContext);

  // eslint-disable-next-line no-unused-vars
  const [ytopts, setOpts] = useState({
    height: "315",
    width: "100%",
    playerVars: {
      autoplay: 1,
    },
  });

  // Handlers

  const artistHasSomeLinks = () => {
    if (currentPlaylist === FAVOURITES_PLAYLIST_ID) return false;
    const artist = artists.find((artist) => artist.id === currentPlaylist);
    if (!artist) return false;
    return (
      artist.www_link?.length > 0 ||
      artist.fb_link?.length > 0 ||
      artist.yt_link?.length > 0
    );
  };

  // Define refs for storing previous values

  // Access the current playlist context
  const {
    currentPlaylist,
    currentVideoIndex,
    setCurrentVideoIndex,
    artists,
    videos,
    activePlaylist,
    activeVideoIndex,
    setActiveVideoIndex,
    activeVideos,
    startPlaying,
  } = useContext(CurrentPlaylistContext);

  const { isFavourite, toggleFavourite } = useContext(FavouritesContext);

  const prevCurrentPlaylist = useRef(currentPlaylist);

  /*   useEffect(() => {
    setCurrentVideoIndex(0);
  }, [currentPlaylist]);

  useEffect(() => {
    updateSongInfo(playlists[currentPlaylist].videos[currentVideoIndex]);
  }, [currentVideoIndex, currentPlaylist]); */

  const toggleVisibility = () => {
    setPlayerVisible(!isPlayerVisible);
    setPlaylistVisible(!isPlaylistVisible);
    const opts = {
      height: { isPlayerVisible } ? "315" : "1px",
      width: { isPlayerVisible } ? "100%" : "1px",
      playerVars: {
        autoplay: 0,
      },
    };
    setOpts(opts);
  };

  useLayoutEffect(() => {
    //console.log(currentPlaylist);
    //console.log(currentVideoIndex);
    //console.log(videos);
  }, []);
  // When browsing playlist changes, reset browsing video index (but don't touch playback)
  useEffect(() => {
    if (currentPlaylist !== prevCurrentPlaylist.current) {
      setCurrentVideoIndex(0);
      prevCurrentPlaylist.current = currentPlaylist;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPlaylist]);

  // When active playlist changes (user started playing), enable autoplay
  useEffect(() => {
    if (activePlaylist !== null && activeVideos.length > 0) {
      shouldAutoplay.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePlaylist, activeVideos]);

  // Update song info from active (playing) state
  useEffect(() => {
    if (activeVideos.length > 0) {
      updateSongInfo(activeVideos[activeVideoIndex >= 0 ? activeVideoIndex : 0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeVideos]);

  useEffect(() => {
    if (activeVideos.length > 0) {
      updateSongInfo(activeVideos[activeVideoIndex]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeVideoIndex]);

  // Track when we're switching videos to maintain autoplay
  const isUserInitiatedSkip = useRef(false);
  // Track whether autoplay should be enabled (false when opening artist from catalogue)
  const shouldAutoplay = useRef(false);

  const onPlayerReady = (event) => {
    // The player is ready
    setIsPlayerReady(true);

    playerRef.current = event.target; // Assign the player instance to playerRef
    setSharedPlayer(event.target); // Also update the shared context

    // Get the duration of the video
    const dur = playerRef.current.getDuration();
    const minutes = Math.floor(dur / 60);
    const seconds = Math.floor(dur % 60);
    const durationformattedTime = `${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    setLocalDuration({ duration: dur, durationformattedTime });
    setSharedDuration(dur); // Also update the shared context
  };

  const onPlayerError = (event) => {
    // The video could not be loaded, e.g. because of a server error or
    // because the video is not embeddable
    console.log("onPlayerError");

    setIsPlayerError(true);
    setIsPlayerReady(false);
    setIsErrorVisible(true); // Show the error message
    playNextVideoForced();
    console.log(`YouTube Player Error: ${event.data}`);
    setTimeout(() => {
      //setIsPlayerReady(true);
      setIsErrorVisible(false); // Hide the error message after 3 seconds
    }, 3000);
  };

  const [time, setTime] = useState({ currentTime: 0, formattedTime: "00:00" });

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        playerRef.current &&
        playerRef.current.getPlayerState &&
        playerRef.current.getPlayerState() === window.YT.PlayerState.PLAYING
      ) {
        const currentTimeInSeconds = playerRef.current.getCurrentTime();
        const minutes = Math.floor(currentTimeInSeconds / 60);
        const seconds = Math.floor(currentTimeInSeconds % 60);
        const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`;
        setTime({ currentTime: currentTimeInSeconds, formattedTime });
      }
    }, 1000); // Update every second

    // Clear interval on component unmount
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time.currentTime]);

  /* useEffect(() => {
    const interval = setInterval(() => {
      console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
      console.log("Player state:", playerRef.current.getPlayerState());
      console.log("isPlayerReady:", isPlayerReady);
      console.log("isPlayerError:", isPlayerError);
      console.log("isPlaying:", isPlaying);
      console.log("isScheduledSkip:", isScheduledSkip);
      console.log("currentVideoIndex:", currentVideoIndex);
    }, 3000); // Log every 3 seconds

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, [
    isPlayerReady,
    isPlayerError,
    isPlaying,
    isScheduledSkip,
    currentVideoIndex,
  ]); */

  const onPlayerStateChange = (event) => {
    console.log(event.data);
    // The player is not ready
    if (event.data === window.YT.PlayerState.BUFFERING) {
      setIsPlayerReady(false);
    }
    // The player is ready
    else if (event.data === window.YT.PlayerState.PLAYING) {
      setIsPlayerError(false);
      setIsPlayerReady(true);
      setIsPlaying(true);
      shouldAutoplay.current = true;
    }
    //player ended
    else if (event.data === window.YT.PlayerState.ENDED) {
      playNextVideo();
      setIsPlaying(false);
    }
    //player paused
    else if (event.data === window.YT.PlayerState.PAUSED) {
      setIsPlayingOrPaused(true);
      setIsPlaying(false);
    } else if (event.data === window.YT.PlayerState.CUED) {
      setIsPlayingOrPaused(false);
      setIsPlaying(false);
    } else if (event.data === window.YT.PlayerState.UNSTARTED) {
      setIsPlayingOrPaused(false);
      setIsPlaying(false);
    } else if (event.data === window.YT.PlayerState.VIDEO_CUED) {
      setIsPlayingOrPaused(false);
      setIsPlaying(false);
    }
  };

  const playNextVideo = () => {
    if (!playerRef.current || activeVideos.length === 0) return;

    // Calculate next video index
    const nextIndex = (activeVideoIndex + 1) % activeVideos.length;
    const nextVideo = activeVideos[nextIndex];

    if (!nextVideo) return;

    // Mark this as user-initiated skip
    isUserInitiatedSkip.current = true;
    shouldAutoplay.current = true;

    // For forced skip (error handling)
    if (isForcedSkip) {
      setIsForcedSkip(false);
      clearTimeout(forcedSkipTimeoutID);
      setActiveVideoIndex(nextIndex);
      return;
    }

    if (isPlayerReady) {
      setIsErrorVisible(false);

      // Use loadVideoById to load and autoplay the next video immediately
      // This maintains the user gesture context for mobile autoplay
      if (playerRef.current.loadVideoById) {
        console.log("Loading next video with autoplay:", nextVideo.video_id);
        playerRef.current.loadVideoById({
          videoId: nextVideo.video_id,
          startSeconds: 0,
        });
        setActiveVideoIndex(nextIndex);
      } else {
        // Fallback to old method
        setActiveVideoIndex(nextIndex);
      }
    }
  };

  const playNextVideoForced = () => {
    setIsForcedSkip(true);
    setForcedSkipTimeoutID(
      setTimeout(() => {
        setActiveVideoIndex((prevIndex) => (prevIndex + 1) % activeVideos.length);
        setIsPlayerReady(false);
        console.log("trying to play next video forced");
      }, 3000),
    ); // Delay of 1 second
  };

  const playPreviousVideo = () => {
    if (!playerRef.current || activeVideos.length === 0) return;

    // Calculate previous video index
    const prevIndex = (activeVideoIndex - 1 + activeVideos.length) % activeVideos.length;
    const prevVideo = activeVideos[prevIndex];

    if (!prevVideo) return;

    // Mark this as user-initiated skip
    isUserInitiatedSkip.current = true;
    shouldAutoplay.current = true;

    // For forced skip (error handling)
    if (isForcedSkip) {
      setIsForcedSkip(false);
      clearTimeout(forcedSkipTimeoutID);
      setActiveVideoIndex(prevIndex);
      return;
    }

    if (isPlayerReady) {
      setIsErrorVisible(false);

      // Use loadVideoById to load and autoplay the previous video immediately
      // This maintains the user gesture context for mobile autoplay
      if (playerRef.current.loadVideoById) {
        console.log(
          "Loading previous video with autoplay:",
          prevVideo.video_id,
        );
        playerRef.current.loadVideoById({
          videoId: prevVideo.video_id,
          startSeconds: 0,
        });
        setActiveVideoIndex(prevIndex);
      } else {
        // Fallback to old method
        setActiveVideoIndex(prevIndex);
      }
    }
  };

  const playpauseVideo = () => {
    // If nothing is actively playing, start playing from current browsing playlist
    if (activeVideos.length === 0 && videos.length > 0) {
      shouldAutoplay.current = true;
      startPlaying(currentPlaylist, currentVideoIndex, videos);
      return;
    }
    if (playerRef.current?.getPlayerState() === window.YT.PlayerState.PAUSED) {
      playerRef.current.playVideo();
      setIsPlaying(true);
      shouldAutoplay.current = true;
    } else if (
      playerRef.current?.getPlayerState() === window.YT.PlayerState.PLAYING
    ) {
      playerRef.current?.pauseVideo();
      setIsPlaying(false);
    } else if (isPlayerReady) {
      playerRef.current.playVideo();
      shouldAutoplay.current = true;
    }
  };

  const updateSongInfo = (video) => {
    console.log(video);
    if (video) {
      setSongInfo({
        title: video.title,
        artist: video.artist,
        lyrics_url: video.lyrics_url,
      });
      setTime({ currentTime: 0, formattedTime: "00:00" });
    }
  };

  const onComplete = () => {
    console.log("onComplete");
  };

  /* const handleProgressBarClick = (event) => {
    // Get the bounding rectangle of target
    const rect = event.target.getBoundingClientRect();

    // Calculate the new time for the video
    //give there some code to debug it better

    const clickPositionInPixels = event.clientX - rect.left;
    const newTime = (clickPositionInPixels / rect.width) * duration;

    // Seek to the new time
    if (player) {
      player.seekTo(newTime);
    }

    // Update the time state
  }; */

  const handleProgressBarClick = (event) => {
    // Get the bounding rectangle of the progress bar
    const rect = event.target.getBoundingClientRect();

    // Calculate the click position within the progress bar
    const clickPositionInPixels = event.clientX - rect.left;

    // Calculate the new time for the video
    const newTime =
      (clickPositionInPixels / rect.width) * localDuration.duration;

    // Seek to the new time
    playerRef.current.seekTo(newTime);

    // Update the time state
    const minutes = Math.floor(newTime / 60);
    const seconds = Math.floor(newTime % 60);
    const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
    setTime({ currentTime: newTime, formattedTime });
  };
  const opts = {
    height: "315",
    width: "100%",
    playerVars: {
      autoplay: shouldAutoplay.current ? 1 : 0,
      controls: 0,
      fs: 0,
      rel: 0,
    },
  };

  const youtubeContainerStyle = {
    position: "relative",
    //pointerEvents: "none", // Set pointerEvents to 'none' to prevent interactions
  };

  // Browsing without active playback, or browsing a different artist than what's playing
  const isBrowsingOnly = activePlaylist === null || activePlaylist !== currentPlaylist;

  return (
    <motion.div
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="card player-container"
    >
      <motion.div layout="position" className="sliding-container">
        {/* YouTube player - always mounted to keep audio playing, hidden when browsing another artist */}
        <div style={isBrowsingOnly ? { position: "absolute", width: "1px", height: "1px", overflow: "hidden", opacity: 0 } : {}}>
          {!isErrorVisible ? (
            <div
              layout="position"
              className={`${!isPlayerVisible ? "hide" : "yt-container"}`}
              style={youtubeContainerStyle}
              href="/youtube"
            >
              {activeVideos.length > 0 ? (
                <YouTube
                  key={`${activePlaylist}-${activeVideoIndex}`}
                  videoId={
                    activeVideos[activeVideoIndex] && activeVideos.length > 0
                      ? activeVideos[activeVideoIndex].video_id
                      : activeVideos[0].video_id
                  }
                  opts={opts}
                  onReady={onPlayerReady}
                  onStateChange={onPlayerStateChange}
                  onError={onPlayerError}
                />
              ) : (
                ""
              )}
            </div>
          ) : isPlayerVisible ? (
            <div className="error-wrapper">
              <motion.div layout className="error-message">
                <i class="fa-regular fa-face-sad-tear"></i>
                <p>Omlouváme se,</p>
                <p>ale skladba není dostupná.</p>
              </motion.div>
            </div>
          ) : (
            ""
          )}
        </div>
        {isBrowsingOnly && (
          <div className="browsing-header">
            <div className="browsing-artist-name">
              {currentPlaylist === FAVOURITES_PLAYLIST_ID
                ? "Oblíbené skladby"
                : artists.find((a) => a.id === currentPlaylist)?.name}
            </div>
            <i
              className="fa-solid fa-circle-play browsing-play-btn"
              onClick={() => {
                shouldAutoplay.current = true;
                startPlaying(currentPlaylist, 0, videos);
              }}
            ></i>
          </div>
        )}
        {!isBrowsingOnly && (
          <>
            <motion.div
              layout="position"
              transition={{ layout: { duration: 0.5 } }}
              onAnimationComplete={onComplete}
              className="wrapper"
            >
              <motion.div layout="position" className="info-card">
                <div className="song-info-wrapper">
                  <div className="artist-info">{songInfo.artist}</div>
                  <div className="song-info">{songInfo.title}</div>
                </div>
                <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                  }}
                >
                  {activeVideos.length > 0 && activeVideos[activeVideoIndex] && (
                    <i
                      className={`favourite-btn-player fa-heart ${isFavourite(activeVideos[activeVideoIndex].video_id) ? "fa-solid active" : "fa-regular"}`}
                      onClick={() => toggleFavourite(activeVideos[activeVideoIndex])}
                      title={
                        isFavourite(activeVideos[activeVideoIndex].video_id)
                          ? "Odebrat z oblíbených"
                          : "Přidat do oblíbených"
                      }
                    ></i>
                  )}
                  {songInfo.title && (
                    <a
                      href={songInfo.lyrics_url || `https://zpevnik.proscholy.cz/hledani?text=${songInfo.title.replace(/\s+/g, "_")}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Najít text písně"
                    >
                      <i
                        className="fa-solid fa-music"
                        style={{ color: "black" }}
                      ></i>
                    </a>
                  )}
                  <i
                    className="playlist-button fa-solid fa-list"
                    onClick={toggleVisibility}
                  ></i>
                </div>
              </motion.div>
              <motion.div layout="position" className="progress-bar-wrapper">
                <div className="song-current-time">{time.formattedTime}</div>

                <ProgressBar
                  variant="moje"
                  className={`player-progress-bar ${
                    isPlayerVisible ? "" : "slide"
                  }`}
                  now={playerRef.current ? playerRef.current.getCurrentTime() : 0}
                  max={playerRef.current ? playerRef.current.getDuration() : 0}
                  onClick={handleProgressBarClick}
                />

                <div className="song-duration">
                  {localDuration.durationformattedTime}
                </div>
              </motion.div>
              <div className="player-controls">
                <i
                  className="fa-solid fa-backward-step skip"
                  onClick={playPreviousVideo}
                ></i>
                {isPlaying ? (
                  <i
                    className="fa-solid fa-circle-pause"
                    onClick={playpauseVideo}
                  ></i>
                ) : (
                  <i
                    className="fa-solid fa-circle-play"
                    onClick={playpauseVideo}
                  ></i>
                )}

                <i
                  className="fa-solid fa-forward-step skip"
                  onClick={playNextVideo}
                ></i>
              </div>
            </motion.div>
          </>
        )}
        {(isBrowsingOnly || isPlaylistVisible) && artistHasSomeLinks() ? (
          <>
            {" "}
            <hr></hr>
            <Links
              artist={artists.find((artist) => artist.id === currentPlaylist)}
            />
            <hr></hr>
          </>
        ) : (
          ""
        )}
        {(isBrowsingOnly || isPlaylistVisible) ? <Playlist /> : ""}
      </motion.div>
    </motion.div>
  );
};

export default Player;
